import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Account, LoyaltyPlan, StoreConfig, FeaturedContent, Order, ConfigService } from 'ngx-web-api';
import { MenuWrapperService } from '../../services/menu-wrapper.service';
import { BreakpointService } from '../../services/breakpoint.service';
import { faFtsProfile } from '../../../shared/custom-fa-icons/faFtsProfile';
import { faFtsRewards } from '../../../shared/custom-fa-icons/faFtsRewards';
import { faFtsOrders } from '../../../shared/custom-fa-icons/faFtsOrders';
import { faFtsAddressBook } from '../../../shared/custom-fa-icons/faFtsAddressBook';
import { faFtsWallet } from '../../../shared/custom-fa-icons/faFtsWallet';
import { faFtsCoupons } from '../../../shared/custom-fa-icons/faFtsCoupons';
import { faFtsDonations } from '../../../shared/custom-fa-icons/faFtsDonations';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { LoyaltySubscription } from 'ngx-web-api/lib/models/core/loyalty-subscription.model';
import { Subject, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-mobile-account-menu',
  templateUrl: './mobile-account-menu.component.html',
  styleUrls: ['./mobile-account-menu.component.scss'],
})
export class MobileAccountMenuComponent implements OnInit, OnDestroy {
  @Input()
  account: Account;
  @Input()
  store: StoreConfig;
  @Input()
  isInIntro: boolean;
  @Input()
  featuredContents: FeaturedContent[];
  @Input()
  minifiedHeader = false;
  @Input()
  order: Order;

  @Output()
  login: EventEmitter<any> = new EventEmitter();
  @Output()
  logout: EventEmitter<any> = new EventEmitter();

  faFtsProfile = faFtsProfile;
  faFtsRewards = faFtsRewards;
  faFtsOrders = faFtsOrders;
  faFtsAddressBook = faFtsAddressBook;
  faFtsWallet = faFtsWallet;
  faFtsCoupons = faFtsCoupons;
  faFtsDonations = faFtsDonations;
  faUsers = faUsers;
  loyaltyPlan: LoyaltyPlan;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    public menuWrapperService: MenuWrapperService,
    public breakpointService: BreakpointService,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.configService.loyaltyPlan$
      .pipe(
        catchError(() => of(null)),
        takeUntil(this.destroy$)
      )
      .subscribe(plan => {
        this.loyaltyPlan = plan;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleLogout(): void {
    this.logout.emit();
  }

  get hasActiveLoyaltySubscriptions(): boolean {
    if (!this.store.hasLoyalty || !this.loyaltyPlan?.loyaltySubscriptions) return false;
    const activeSubs = this.loyaltyPlan.loyaltySubscriptions.filter((sub: LoyaltySubscription) => sub.active);
    return activeSubs.length > 0;
  }

  handleLogin() {
    this.login.emit();
  }
}
